import { FC, memo, useContext } from 'react';
import Text, { TEXT } from 'src/view/components/Text/Text';
import MultiLanguageInput from 'src/view/components/Controls/MultiLanguageInput/MultiLanguageInput';
import { ILangTextValidation, TTranslate } from 'src/types/main';
import { LOCALES } from 'src/constants/main';
import { defaultIntegrationTooltipOptions } from 'src/constants/integrations';
import { TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import { RestrictionAccessContext } from 'src/view/containers/Modals/DineInSectionModal/DineInSectionModal';
import { localeStore } from 'src/mobx/localesStore';

interface IProps {
  name: TTranslate;
  validation: ILangTextValidation;
  onChangeName: (value: string, locale: LOCALES) => void;
}

const SectionName: FC<IProps> = ({ name, validation, onChangeName }): JSX.Element => {
  const { isDisabledForEditing } = useContext(RestrictionAccessContext);

  return (
    <>
      <Text text="section_name" type={TEXT.BLOCK_HEADER} className="mb-2" disabled={isDisabledForEditing} required />
      <MultiLanguageInput
        arText={name.ar}
        enText={name.en}
        placeholder={localeStore.t('type_in_section_name')}
        wrapperClassName="full-width"
        className="full-width"
        validation={validation}
        tooltip={isDisabledForEditing ? { ...defaultIntegrationTooltipOptions, position: TOOLTIP_POSITION.PORTAL } : undefined}
        disabled={isDisabledForEditing}
        onChangeValue={onChangeName}
      />
    </>
  );
};

export default memo(SectionName);
